import { useState } from 'react'
import Image from 'next/image'
import { cn } from '@desoutter/uikit/src/utils'

export default function CustomImage({
	src,
	alt,
	width,
	height,
	className,
	fallbackSrc = '/images/box.svg', // Default fallback
}: {
	src?: string
	alt: string
	width: number
	height: number
	className?: string
	fallbackSrc?: string
}) {
	const [imgSrc, setImgSrc] = useState(src || fallbackSrc)
	const [hasError, setHasError] = useState(false)

	const handleError = () => {
		if (!hasError && imgSrc !== fallbackSrc) {
			setImgSrc(fallbackSrc)
			setHasError(true)
		} else {
			// If fallback also fails, hide the image
			setImgSrc('')
		}
	}

	// Don't render anything if no valid image source
	if (!imgSrc) {
		return null
	}

	return (
		<Image
			src={imgSrc}
			alt={alt}
			width={width}
			height={height}
			className={cn(className, {
				'opacity-20': hasError,
			})}
			onError={handleError}
		/>
	)
}
